import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';
import ReactGA from 'react-ga';

import RedeemFormView from 'src/Components/RedeemForm';
import { redeemCode } from 'src/GraphQL/mutation/LinkMockExam.mutation';
import { getMyMockExamList } from 'src/GraphQL/query/MockExam.query';

const RESULT_MAP = {
  OTHERS: 'เกิดข้อผิดพลาด กรุณาตรวจสอบรหัสอีกครั้ง',
  USED: 'รหัสนี้ถูกนำไปใช้แล้ว กรุณาตรวจสอบรหัสอีกครั้ง',
  NOT_FOUND: 'ไม่มีรหัสนี้ในระบบ กรุณาตรวจสอบรหัสอีกครั้ง',
};

const getErrorMessage = (subCode, message) => {
  if (!subCode) return message;
  return RESULT_MAP[subCode];
};

export default class Redeem extends Component {
  handleSubmit = (formData, linkFn) => {
    linkFn({
      variables: { examLinkCode: formData.code.trim() },
      refetchQueries: [{ query: getMyMockExamList }],
    });
    try {
      ReactGA.event({
        category: 'MOCKEXAM',
        action: 'Click redeem',
      });
    } catch (err) {
      console.err('ga error:', err);
    }
  };

  render() {
    return (
      <Mutation mutation={redeemCode}>
        {(linkMockExams, { data, loading, error, called }) => {
          let resultLinkmockExams, result;
          if (data) {
            resultLinkmockExams = data.linkMockExams || {};
            result = {
              success: resultLinkmockExams.success,
              code: resultLinkmockExams.code,
              message: getErrorMessage(resultLinkmockExams.subCode, resultLinkmockExams.message),
              subCode: resultLinkmockExams.subCode,
            };
            try {
              ReactGA.event({
                category: 'MOCKEXAM',
                action: 'Redeem success',
              });
            } catch (err) {
              console.err('ga error:', err);
            }
          } else {
            try {
              ReactGA.event({
                category: 'MOCKEXAM',
                action: 'Redeem failed',
                label: error,
              });
            } catch (err) {
              console.err('ga error:', err);
            }
          }
          return (
            <Fragment>
              <RedeemFormView
                disabled={loading}
                onSubmit={formData => {
                  this.handleSubmit(formData, linkMockExams);
                }}
                result={result}
                {...this.props}
              />
              {error && JSON.stringify(error)}
            </Fragment>
          );
        }}
      </Mutation>
    );
  }
}
